
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PersonalInfoSectionProps {
  name: string;
  setName: (value: string) => void;
  title: string;
  setTitle: (value: string) => void;
  company: string;
  setCompany: (value: string) => void;
  photoUrl: string;
  setPhotoUrl: (value: string) => void;
}

const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({
  name,
  setName,
  title,
  setTitle,
  company,
  setCompany,
  photoUrl,
  setPhotoUrl
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          {t('production.form.name')} *
        </label>
        <input
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          required
        />
      </div>
      
      <div>
        <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
          {t('production.form.title')}
        </label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1">
          {t('production.form.company')}
        </label>
        <input
          id="company"
          type="text"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>
      
      <div>
        <label htmlFor="photoUrl" className="block text-sm font-medium text-gray-700 mb-1">
          {t('production.form.profileUrl')}
        </label>
        <input
          id="photoUrl"
          type="text"
          value={photoUrl}
          onChange={(e) => setPhotoUrl(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="https://..."
        />
        <p className="mt-1 text-sm text-gray-500">
          {t('production.form.profileUrlHelp')}{" "}
          <a href="/simple-photo-upload" className="text-blue-500 hover:underline">
            image upload
          </a>
        </p>
      </div>
    </div>
  );
};

export default PersonalInfoSection;
